import { cls } from '@/utils/cls';
import { format } from '@/utils/format';

export type FilterChip = {
  label: string;
  color: 'product' | 'customer' | 'orders' | 'forecast';
};

type ActiveFiltersBarProps = {
  className?: string;
  chips: FilterChip[];
  onClear?: () => void;
  maxVisible?: number;
  showLabel?: boolean;
};

const COLOR_STYLES: Record<FilterChip['color'], string> = {
  product: 'bg-blue-50 text-blue-700 border-blue-200',
  customer: 'bg-cyan-50 text-cyan-700 border-cyan-200',
  orders: 'bg-amber-50 text-amber-700 border-amber-200',
  forecast: 'bg-slate-100 text-slate-700 border-slate-200',
};

export function ActiveFiltersBar({
  chips,
  className,
  onClear,
  maxVisible = 12,
  showLabel = true,
}: ActiveFiltersBarProps) {
  if (!chips || chips.length === 0) return null;

  const containerClass =
    'mt-3 flex flex-wrap items-center gap-2 rounded-md border border-slate-200 bg-white px-3 py-3 text-sm';
  const visible = chips.slice(0, maxVisible);
  const hiddenCount = chips.length - visible.length;

  return (
    <div className={cls(containerClass, className)}>
      {showLabel ? <span className="font-semibold text-slate-700">Applied filters</span> : null}

      {visible.map((chip, index) => (
        <span
          key={`${chip.label}-${index}`}
          className={`inline-flex items-center rounded-full border px-2 py-0.5 text-xs font-semibold ${COLOR_STYLES[chip.color]}`}
        >
          {chip.label}
        </span>
      ))}

      {hiddenCount > 0 ? (
        <span className="text-xs font-semibold text-slate-500">
          {format('+{{count}} more', { count: hiddenCount })}
        </span>
      ) : null}

      {onClear ? (
        <button
          type="button"
          onClick={onClear}
          className="ml-auto rounded-md px-2 py-1 text-xs font-semibold text-slate-600 hover:bg-slate-100"
        >
          Clear all
        </button>
      ) : null}
    </div>
  );
}
